import axios from "axios";
import config from "@/config";
import { getToken } from "@/libs/util";
const baseUrl =
  process.env.NODE_ENV === "development"
    ? config.baseUrl.dev
    : config.baseUrl.pro;
const stranges={
  queryStationByFilter:"/sys/station/queryStationByFilter",
  queryStationById:'/sys/station/queryStationById/',
  queryNodeById:'/sys/node/queryNodeById/',
  queryChannelById :'/sys/channel/queryChannelById/', 
  queryClientList :'/client/queryClientList', 
  queryClientById :'/client/queryClientById/', 
  queryStationList:'/sys/station/queryStationList',
  queryNodeList:'/sys/node/queryNodeList',
  queryChannelList :'/sys/channel/queryChannelList', 
  querySensorByFilter :'/sys/sensor/querySensorByFilter',
  fuzzyQueryStationList:"/sys/station/fuzzyQueryStationList",
  fuzzyQueryNodeList:"/sys/node/fuzzyQueryNodeList",
  fuzzyQueryChannelList:"/sys/channel/fuzzyQueryChannelList",
  queryProjectList :'/sys/project/queryProjectList',
  queryProjectById :'/sys/project/queryProjectById/',
  queryPointList :'/sys/point/queryPointList',
  queryDirectoryByFilter:'/sys/directory/queryDirectoryByFilter/',
  queryDirectoryById:'/sys/directory/queryDirectoryById/',
  queryDirectoryList:'/sys/directory/queryDirectoryList',
  queryPointByFilter:'/sys/point/queryPointByFilter',
  queryPointById:'/sys/point/queryPointById/',
  queryPage:'/sys/incline/queryPage',
  queryNodeDateList:'/sys/incline/queryNodeDateList',
  queryGroupByDay:'/sys/incline/queryGroupByDay',
  queryDataByNodeId:'/sys/incline/queryDataByNodeId',
  querySensorList:'/sys/incline/querySensorList?dirId=',
  querySensorData:'/sys/incline/querySensorData',
  querySensorRelativeDisp:'/sys/incline/querySensorRelativeDisp',
  queryDataByNodeId:'/sys/incline/queryDataByNodeId',
  setOriginal:'/sys/incline/setOriginal',
  clientSubList:'/client/subList/',
  projectSubList:'/sys/project/subList/',
  directorySubList:'/sys/directory/subList/',
  stationSubList:'/sys/station/subList/',
  nodeSubList:'/sys/node/subList/',
  channelSubList:'/sys/channel/subList/',
  clientRoot:'/client/root',
  clientLocate:'/sys/tree/locate/',
  deleteByDirId:'/sys/incline/deleteByDirId',
  getOriginalValues:'/sys/incline/getOriginalValues/',
}
export default function(method,apiname,params,path){
    if(!path){
        path=''
    }
    return axios.request({
        method:method,
        url:baseUrl+stranges[apiname]+path,
        headers:{
            // token:localStorage['token'],
            token:getToken(),
            "Content-Type": "application/json; charset=utf-8"  
        },
        data:params,
    })
}